import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';

type GetViewLinkResponse = {
    url?: string;
    file?: string;
};

async function getViewLink(recordId: string): Promise<GetViewLinkResponse> {
    const { data } = await api.get('/file-records/documents/view', {
        params: {
            recordId,
        },
    });

    return data;
}

export function useViewLink(recordId: string, enabled: boolean): UseQueryResult<GetViewLinkResponse, AxiosError> {
    return useQuery(['view', recordId], () => getViewLink(recordId), {
        enabled,
        cacheTime: 0,
        staleTime: 0,
        retry: false,
    });
}
